import { render, staticRenderFns } from "./VesselsFormBlock.vue?vue&type=template&id=60b0ae7c"
import script from "./VesselsFormBlock.vue?vue&type=script&lang=js"
export * from "./VesselsFormBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports